var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-left_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chevron-left_svg__chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.71 6.71a.996.996 0 0 0-1.41 0L8.71 11.3a.996.996 0 0 0 0 1.41l4.59 4.59a.996.996 0 1 0 1.41-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41",
    className: "chevron-left_svg__vector"
  }))));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5DaGV2cm9uIExlZnQ8L3RpdGxlPjxnIGNsYXNzPSJjaGV2cm9uLWxlZnQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE0LjcxIDYuNzFhLjk5Ni45OTYgMCAwIDAtMS40MSAwTDguNzEgMTEuM2EuOTk2Ljk5NiAwIDAgMCAwIDEuNDFsNC41OSA0LjU5YS45OTYuOTk2IDAgMSAwIDEuNDEtMS40MUwxMC44MyAxMmwzLjg4LTMuODhjLjM5LS4zOS4zOC0xLjAzIDAtMS40MVoiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";